import React from 'react';
import { connect } from 'react-redux';
import {Grid, Row, Col} from 'react-bootstrap';
import Layout from '../../components/layout/Layout';
import Card from '../../components/card/Card';
import { defaultRejectHandler } from '../../utils/utility';
import { translate } from 'react-i18next';

import { listProjectLocation } from '../../redux/projects/project_location_actions';
import { listBuildingType } from '../../redux/building_type/building_type_actions';
import { listProvinces } from '../../redux/provinces/province_actions';
import {
  getProjectStats,
  getOttvStats,
  getRttvStats,
  getLpdStats,
  getCopStats,
  getSeerStats,
  getBoilerStats,
  getHotWaterCopStats,
  getPveStats,
  getHeeStats,
  getOtherReStats,
  getLightingPowerStats,
  clearAllStats,
} from '../../redux/stat/stat_actions';

import '../../components/default.css';
import SummaryCard from '../../components/summarycard/SummaryCard';
import StatChartTab from '../../components/charts/StatChartTab';
import { Button, Form, FormGroup, ControlLabel, FormControl, Tabs, Tab } from 'react-bootstrap';
import Constants from '../../config/constants';
import ErrorModal from '../../modal/util/ErrorModal';
import axios from 'axios';

// Chart configurations for all tabs
const CHART_CONFIGS = [
  {
    eventKey: 'ottv',
    tabTitle: 'OTTV',
    chartTitleTh: 'ค่าการถ่ายเทความร้อนรวมของผนังด้านนอกอาคาร (OTTV)',
    chartTitleEn: 'Overall Thermal Transfer Value; OTTV',
    yAxisLabel: 'OTTV (W/m²)',
    dataKey: 'ottvData',
    loadingKey: 'ottvLoading',
    color: '#5B8FF9',
  },
  {
    eventKey: 'rttv',
    tabTitle: 'RTTV',
    chartTitleTh: 'ค่าการถ่ายเทความร้อนรวมของหลังคาอาคาร (RTTV)',
    chartTitleEn: 'Roof Thermal Transfer Value; RTTV',
    yAxisLabel: 'RTTV (W/m²)',
    dataKey: 'rttvData',
    loadingKey: 'rttvLoading',
    color: '#61DDAA',
  },
  {
    eventKey: 'lpd',
    tabTitle: 'LPD',
    chartTitleTh: 'ค่ากำลังไฟฟ้าส่องสว่างสูงสุด (LPD)',
    chartTitleEn: 'Lighting power density; LPD',
    yAxisLabel: 'LPD (W/m²)',
    dataKey: 'lpdData',
    loadingKey: 'lpdLoading',
    color: '#65789B',
  },
  {
    eventKey: 'lightingPower',
    tabTitleTh: 'กำลังไฟฟ้าแสงสว่าง',
    tabTitleEn: 'Lighting Power',
    chartTitleTh: 'ค่ากำลังไฟฟ้าของระบบไฟฟ้าแสงสว่าง',
    chartTitleEn: 'Lighting system power',
    yAxisLabelTh: 'กิโลวัตต์',
    yAxisLabelEn: 'kW',
    dataKey: 'lightingPowerData',
    loadingKey: 'lightingPowerLoading',
    color: '#F6BD16',
    avgSuffix: ' kW',
  },
  {
    eventKey: 'cop',
    tabTitle: 'COP',
    chartTitleTh: 'ค่าสัมประสิทธิ์สมรรถนะขั้นต่ำของอาคาร (COP)',
    chartTitleEn: 'Coefficient of performance; COP',
    yAxisLabel: 'COP',
    dataKey: 'copData',
    loadingKey: 'copLoading',
    color: '#7262FD',
  },
  {
    eventKey: 'seer',
    tabTitle: 'SEER',
    chartTitleTh: 'ค่าประสิทธิภาพพลังงานตามฤดูกาล (SEER)',
    chartTitleEn: 'Seasonal energy efficiency ratio; SEER',
    yAxisLabel: 'SEER',
    dataKey: 'seerData',
    loadingKey: 'seerLoading',
    color: '#78D3F8',
  },
  {
    eventKey: 'boiler',
    tabTitle: 'Boiler',
    chartTitleTh: 'ค่าประสิทธิภาพขั้นต่ำของหม้อไอน้ำ (Boiler)',
    chartTitleEn: 'Minimum efficiency of boiler',
    yAxisLabel: '%',
    dataKey: 'boilerData',
    loadingKey: 'boilerLoading',
    color: '#F6903D',
    avgSuffix: '%',
  },
  {
    eventKey: 'hotWaterCop',
    tabTitleTh: 'COP น้ำร้อน',
    tabTitleEn: 'Hot Water COP',
    chartTitleTh: 'ค่าสัมประสิทธิ์สมรรถนะขั้นต้นของน้ำร้อน (ฮีตปั๊ม)',
    chartTitleEn: 'Initial COP of hot water (heat pump)',
    yAxisLabel: 'COP',
    dataKey: 'hotWaterCopData',
    loadingKey: 'hotWaterCopLoading',
    color: '#F08BB4',
  },
  {
    eventKey: 'pv',
    tabTitleTh: 'พลังงานแสงอาทิตย์',
    tabTitleEn: 'PV Energy',
    chartTitleTh: 'ค่าพลังงานหมุนเวียนที่ผลิตโดยเซลล์แสงอาทิตย์ (กิโลวัตต์ชั่วโมงต่อปี)',
    chartTitleEn: 'Renewable energy by PV (kWh/y)',
    yAxisLabel: 'kWh/y',
    dataKey: 'pveData',
    loadingKey: 'pveLoading',
    color: '#5AD8A6',
    avgSuffix: ' kWh/y',
  },
  {
    eventKey: 'heatToElec',
    tabTitleTh: 'ความร้อนเทียบไฟฟ้า',
    tabTitleEn: 'Heat to Electricity',
    chartTitleTh: 'ค่าพลังงานความร้อนหมุนเวียนเทียบเป็นพลังงานไฟฟ้า (กิโลวัตต์ชั่วโมงต่อปี)',
    chartTitleEn: 'Renewable heat to electricity (kWh/y)',
    yAxisLabel: 'kWh/y',
    dataKey: 'heeData',
    loadingKey: 'heeLoading',
    color: '#6DC8EC',
    avgSuffix: ' kWh/y',
  },
  {
    eventKey: 'otherRe',
    tabTitleTh: 'พลังงานหมุนเวียนอื่น',
    tabTitleEn: 'Other RE',
    chartTitleTh: 'ค่าพลังงานหมุนเวียนในรูปแบบอื่น ๆ (กิโลวัตต์ชั่วโมงต่อปี)',
    chartTitleEn: 'Other renewable energy (kWh/y)',
    yAxisLabel: 'kWh/y',
    dataKey: 'otherReData',
    loadingKey: 'otherReLoading',
    color: '#9270CA',
    avgSuffix: ' kWh/y',
  },
];

class InspectionDashboardPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      projectId: this.props.match.params.projectId,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isShowUploadImageModal: false,
      isShowErrorModal: false,
      errorMessage: null,
      selectedBuildingTypeId: '',
      selectedProvinceId: '',
      areaOptions: [
        { id: '0', labelTh: 'น้อยกว่า 2,000 ตร.ม.', labelEn: '< 2,000 m²' },
        { id: '1', labelTh: '2,000 – 5,000 ตร.ม.', labelEn: '2,000 – 5,000 m²' },
        { id: '2', labelTh: '5,001 – 10,000 ตร.ม.', labelEn: '5,001 – 10,000 m²' },
        { id: '3', labelTh: '10,001 – 30,000 ตร.ม.', labelEn: '10,001 – 30,000 m²' },
        { id: '4', labelTh: '30,001 – 50,000 ตร.ม.', labelEn: '30,001 – 50,000 m²' },
        { id: '5', labelTh: 'มากกว่า 50,000 ตร.ม.', labelEn: '> 50,000 m²' },
      ],
      selectedAreaBucket: '',
      dateFrom: '',
      dateTo: '',
      activeTab: 'ottv',
    };

    this.defaultStatus = 'unset';

    this.statusMapper = {
      unset: 'status-pending',
      failed: 'status-failed',
      passed: 'status-passed',
    };

    // Map eventKey to load function
    this.loadFunctions = {
      ottv: params => this.props.getOttvStats(params),
      rttv: params => this.props.getRttvStats(params),
      lpd: params => this.props.getLpdStats(params),
      lightingPower: params => this.props.getLightingPowerStats(params),
      cop: params => this.props.getCopStats(params),
      seer: params => this.props.getSeerStats(params),
      boiler: params => this.props.getBoilerStats(params),
      hotWaterCop: params => this.props.getHotWaterCopStats(params),
      pv: params => this.props.getPveStats(params),
      heatToElec: params => this.props.getHeeStats(params),
      otherRe: params => this.props.getOtherReStats(params),
    };
  }

  componentWillReceiveProps(nextProps) {
  }

  componentDidMount() {
    this.props.listProjects();
    this.props.listBuildingTypes();
    this.props.listProvinces();
    this.props.getProjectStats(this.buildFilterParams());
    // Load only the default tab data
    this.loadTabData('ottv');
  }

  // Build filter params for API calls
  buildFilterParams() {
    const params = {
      status: 'SUB',  // Always filter by submitted status
    };
    
    if (this.state.selectedProvinceId) {
      params.province_id = this.state.selectedProvinceId;
    }
    if (this.state.selectedBuildingTypeId) {
      params.building_type_id = this.state.selectedBuildingTypeId;
    }
    if (this.state.selectedAreaBucket) {
      params.area_range = this.state.selectedAreaBucket;
    }
    if (this.state.dateFrom) {
      params.date_from = this.state.dateFrom;
    }
    if (this.state.dateTo) {
      params.date_to = this.state.dateTo;
    }
    
    return params;
  }

  loadTabData(tabKey) {
    const params = this.buildFilterParams();
    const config = CHART_CONFIGS.find(c => c.eventKey === tabKey);
    if (!config) return;

    const data = this.props[config.dataKey];
    const loading = this.props[config.loadingKey];
    const loadFn = this.loadFunctions[tabKey];

    if (!data && !loading && loadFn) {
      loadFn(params);
    }
  }

  loadTabDataForced(tabKey) {
    const params = this.buildFilterParams();
    const loadFn = this.loadFunctions[tabKey];
    if (loadFn) {
      loadFn(params);
    }
  }

  handleTabSelect = (tabKey) => {
    this.setState({ activeTab: tabKey });
    this.loadTabData(tabKey);
  }

  renderActionMenu() {
    return [];
  }

  componentDidUpdate(prevProps) {
    // Area options are now static in state initialization
  }

  // Handle search button click
  handleSearch = () => {
    // Clear all existing data to force reload
    this.props.clearAllStats();
    // Load current tab data and project stats with new filters after state clears
    setTimeout(() => {
      this.props.getProjectStats(this.buildFilterParams());
      this.loadTabDataForced(this.state.activeTab);
    }, 0);
  }

  // Handle clear filters button click
  handleClearFilters = () => {
    this.setState({
      selectedBuildingTypeId: '',
      selectedProvinceId: '',
      selectedAreaBucket: '',
      dateFrom: '',
      dateTo: '',
    }, () => {
      // Clear all data and reload current tab and project stats
      this.props.clearAllStats();
      setTimeout(() => {
        this.props.getProjectStats(this.buildFilterParams());
        this.loadTabDataForced(this.state.activeTab);
      }, 0);
    });
  }

  // Handle export report button click
  handleExportReport = () => {
    const params = this.buildFilterParams();
    
    // Get auth token
    const accessToken = localStorage.getItem('access-token');
    const headers = {};
    if (accessToken) {
      headers['Authorization'] = `Token ${accessToken}`;
    }

    // Use axios for file download (handles CORS like other API calls)
    axios({
      method: 'get',
      url: Constants.API_PROJECT_STAT_REPORT,
      params: params,
      headers: headers,
      responseType: 'blob',
    })
      .then(response => {
        // Get filename from Content-Disposition header if available
        const contentDisposition = response.headers['content-disposition'];
        let filename = 'report.xlsx';
        if (contentDisposition) {
          const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (match && match[1]) {
            filename = match[1].replace(/['"]/g, '');
          }
        }
        
        // Create download link
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      })
      .catch(err => {
        console.error('Export error:', err);
        this.setState({
          isShowErrorModal: true,
          errorMessage: 'ไม่สามารถออกรายงานได้ / Export failed',
        });
      });
  }

  dismissErrorModal = () => {
    this.setState({ isShowErrorModal: false, errorMessage: null });
  }

  renderSummaryCards() {
    const lang = this.props.i18n.language.split('-')[0];
    const l = (th, en) => (lang === 'th' ? th : en);
    const stats = this.props.projectStats;
    const toGWh = kwh => (kwh == null ? null : (kwh / 1e6));
    const toKtoe = kwh => (kwh == null ? null : (kwh / 11630000)); // 1 toe ≈ 11,630 kWh
    const toMillionBaht = baht => (baht == null ? null : (baht / 1e6)); // แปลงเป็นล้านบาท
    const toTonsCO2 = val => (val == null ? null : (val / 1e6)); // แปลงเป็น tons CO₂
    
    const savingEnergyKWh = stats && stats.totals ? stats.totals.saving_energy : null;
    const costSaving = stats && stats.totals ? stats.totals.cost_saving : null;
    const co2Reduction = stats && stats.totals ? stats.totals.co2_reduction : null;
    
    const savingGWh = toGWh(savingEnergyKWh);
    const savingKtoe = toKtoe(savingEnergyKWh);
    const costSavingMillionBaht = toMillionBaht(costSaving);
    const co2ReductionTons = toTonsCO2(co2Reduction);
    
    const format = value => {
      if (value == null || isNaN(value)) return null;
      const str = value.toLocaleString(undefined, { maximumFractionDigits: 2 });
      return str;
    };
    return (
      <Row className="show-grid">
        <Col xs={12} md={6} lg={3}>
          <SummaryCard
            title={l('ผลประหยัด', 'Savings')}
            iconClass="fas fa-bolt"
            number={format(savingGWh) || '-'}
            unit={l('GWh/ปี', 'GWh/y')}
            iconColor="#5B8FF9"
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <SummaryCard
            title={l('ลดการใช้พลังงานไฟฟ้า', 'Reduced electricity consumption')}
            iconClass="fas fa-tint"
            number={format(savingKtoe) || '-'}
            unit={l('ktoe/ปี', 'ktoe/y')}
            iconColor="#61DDAA"
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <SummaryCard
            title={l('ประหยัดค่าใช้จ่าย', 'Cost saving')}
            iconClass="fas fa-piggy-bank"
            number={format(costSavingMillionBaht) || '-'}
            unit={l('ล้านบาท/ปี', 'million THB/y')}
            iconColor="#F6903D"
          />
        </Col>
        <Col xs={12} md={6} lg={3}>
          <SummaryCard
            title={l('ลดการใช้ก๊าซ CO₂', 'CO₂ reduction')}
            iconClass="fas fa-cloud"
            number={format(co2ReductionTons) || '-'}
            unit={l('tons CO₂/ปี', 'tons CO₂/y')}
            iconColor="#F5222D"
          />
        </Col>
      </Row>
    );
  }

  renderFilterBar() {
    const lang = this.props.i18n.language.split('-')[0];
    const l = (th, en) => (lang === 'th' ? th : en);
    const buildingTypeLabel = bt => bt[`name_${lang}`] || bt.name || bt.label;
    return (
      <Row className="show-grid">
        <Col xs={12}>
          <Card header={l('ตัวกรอง (Filter)', 'Filter')} padding={true}>
            <Form horizontal>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>{l('ประเภทอาคาร', 'Building type')}</Col>
                <Col sm={4}>
                  <FormControl
                    componentClass="select"
                    placeholder={l('ทั้งหมด', 'All')}
                    value={this.state.selectedBuildingTypeId}
                    onChange={e => this.setState({ selectedBuildingTypeId: e.target.value })}
                  >
                    <option value="">{l('ทั้งหมด', 'All')}</option>
                    {this.props.buildingTypes.map(bt => (
                      <option key={bt.id} value={bt.id}>{buildingTypeLabel(bt)}</option>
                    ))}
                  </FormControl>
                </Col>
                <Col componentClass={ControlLabel} sm={2}>{l('พื้นที่อาคาร', 'Building area')}</Col>
                <Col sm={4}>
                  <FormControl
                    componentClass="select"
                    placeholder={l('ทั้งหมด', 'All')}
                    value={this.state.selectedAreaBucket}
                    onChange={e => this.setState({ selectedAreaBucket: e.target.value })}
                  >
                    <option value="">{l('ทั้งหมด', 'All')}</option>
                    {this.state.areaOptions.map(opt => (
                      <option key={opt.id} value={opt.id}>{l(opt.labelTh, opt.labelEn)}</option>
                    ))}
                  </FormControl>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>{l('จังหวัด', 'Province')}</Col>
                <Col sm={4}>
                  <FormControl
                    componentClass="select"
                    placeholder={l('ทั้งหมด', 'All')}
                    value={this.state.selectedProvinceId}
                    onChange={e => this.setState({ selectedProvinceId: e.target.value })}
                  >
                    <option value="">{l('ทั้งหมด', 'All')}</option>
                    {this.props.provinces.map(pv => (
                      <option key={pv.id} value={pv.id}>{pv.name}</option>
                    ))}
                  </FormControl>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>{l('ช่วงวันที่', 'Date range')}</Col>
                <Col sm={4}>
                  <FormControl 
                    type="date" 
                    value={this.state.dateFrom}
                    onChange={e => this.setState({ dateFrom: e.target.value })}
                  />
                </Col>
                <Col componentClass={ControlLabel} sm={2}>{l('ถึง', 'To')}</Col>
                <Col sm={4}>
                  <FormControl 
                    type="date" 
                    value={this.state.dateTo}
                    onChange={e => this.setState({ dateTo: e.target.value })}
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col smOffset={2} sm={10}>
                  <Button bsStyle="primary" style={{ marginRight: 8 }} onClick={this.handleSearch}>
                    {l('ค้นหา', 'Search')}
                  </Button>
                  <Button style={{ marginRight: 8 }} onClick={this.handleClearFilters}>
                    {l('ล้างค่า', 'Clear')}
                  </Button>
                  <Button bsStyle="success" onClick={this.handleExportReport}>
                    <i className="fas fa-file-export" style={{ marginRight: 6 }} />
                    {l('ออกรายงาน', 'Export Report')}
                  </Button>
                </Col>
              </FormGroup>
            </Form>
          </Card>
        </Col>
      </Row>
    );
  }

  renderChartTabs() {
    const lang = this.props.i18n.language.split('-')[0];
    const l = (th, en) => (lang === 'th' ? th : en);

    return CHART_CONFIGS.map(config => {
      // Handle localized tab title
      const tabTitle = config.tabTitle || l(config.tabTitleTh, config.tabTitleEn);
      // Handle localized y-axis label
      const yAxisLabel = config.yAxisLabel || l(config.yAxisLabelTh, config.yAxisLabelEn);

      return (
        <Tab key={config.eventKey} eventKey={config.eventKey} title={tabTitle}>
          <StatChartTab
            chartTitleTh={config.chartTitleTh}
            chartTitleEn={config.chartTitleEn}
            yAxisLabel={yAxisLabel}
            data={this.props[config.dataKey]}
            loading={this.props[config.loadingKey]}
            color={config.color}
            avgSuffix={config.avgSuffix}
            lang={lang}
          />
        </Tab>
      );
    });
  }

  render() {
    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={[]}
        renderActionMenu={() => this.renderActionMenu()}
      >
        <ErrorModal
          show={this.state.isShowErrorModal}
          errorMessage={this.state.errorMessage}
          onHide={this.dismissErrorModal}
        />
        <Grid>
          {this.renderSummaryCards()}
          {this.renderFilterBar()}
          <Row className="show-grid">
            <Col xs={12}>
              <div className="white-tabs">
              <Tabs 
                id="inspection-charts-tabs" 
                activeKey={this.state.activeTab}
                onSelect={this.handleTabSelect}
              >
                  {this.renderChartTabs()}
              </Tabs>
              </div>
            </Col>
          </Row>
        </Grid>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  projects: state.projectLocation.orderedIds.map(id => state.projectLocation.objects[id]),
  isLoading: state.projectLocation.isLoading,
  errorMessage: state.project.errorMessage,
  // Building types from Redux
  buildingTypes: state.buildingType.orderedIds.map(id => state.buildingType.buildingTypes[id]),
  buildingTypesLoading: state.buildingType.loading,
  // Provinces from Redux
  provinces: state.province.orderedIds.map(id => state.province.provinces[id]),
  provincesLoading: state.province.loading,
  // Project stats
  projectStats: state.stat.projectStats,
  projectStatsLoading: state.stat.projectStatsLoading,
  // All stat data from Redux
  ottvData: state.stat.ottvData,
  ottvLoading: state.stat.ottvLoading,
  rttvData: state.stat.rttvData,
  rttvLoading: state.stat.rttvLoading,
  lpdData: state.stat.lpdData,
  lpdLoading: state.stat.lpdLoading,
  copData: state.stat.copData,
  copLoading: state.stat.copLoading,
  seerData: state.stat.seerData,
  seerLoading: state.stat.seerLoading,
  boilerData: state.stat.boilerData,
  boilerLoading: state.stat.boilerLoading,
  hotWaterCopData: state.stat.hotWaterCopData,
  hotWaterCopLoading: state.stat.hotWaterCopLoading,
  pveData: state.stat.pveData,
  pveLoading: state.stat.pveLoading,
  heeData: state.stat.heeData,
  heeLoading: state.stat.heeLoading,
  otherReData: state.stat.otherReData,
  otherReLoading: state.stat.otherReLoading,
  lightingPowerData: state.stat.lightingPowerData,
  lightingPowerLoading: state.stat.lightingPowerLoading,
});

const mapDispatchToProps = dispatch => ({
  listProjects: () => defaultRejectHandler(dispatch(listProjectLocation())),
  listBuildingTypes: () => defaultRejectHandler(dispatch(listBuildingType())),
  listProvinces: () => defaultRejectHandler(dispatch(listProvinces())),
  getProjectStats: (params) => defaultRejectHandler(dispatch(getProjectStats(params))),
  getOttvStats: (params) => defaultRejectHandler(dispatch(getOttvStats(params))),
  getRttvStats: (params) => defaultRejectHandler(dispatch(getRttvStats(params))),
  getLpdStats: (params) => defaultRejectHandler(dispatch(getLpdStats(params))),
  getCopStats: (params) => defaultRejectHandler(dispatch(getCopStats(params))),
  getSeerStats: (params) => defaultRejectHandler(dispatch(getSeerStats(params))),
  getBoilerStats: (params) => defaultRejectHandler(dispatch(getBoilerStats(params))),
  getHotWaterCopStats: (params) => defaultRejectHandler(dispatch(getHotWaterCopStats(params))),
  getPveStats: (params) => defaultRejectHandler(dispatch(getPveStats(params))),
  getHeeStats: (params) => defaultRejectHandler(dispatch(getHeeStats(params))),
  getOtherReStats: (params) => defaultRejectHandler(dispatch(getOtherReStats(params))),
  getLightingPowerStats: (params) => defaultRejectHandler(dispatch(getLightingPowerStats(params))),
  clearAllStats: () => dispatch(clearAllStats()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(InspectionDashboardPage),
);



// WEBPACK FOOTER //
// ./src/pages/inspection_dashboard/InspectionDashboardPage.js